import R from 'app/assets/R'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { SectionBase } from 'app/components/common/SectionBase'
import { useTranslation } from 'react-i18next'
import { useHook } from './hook'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'

export const ListPatientTodayLayout = () => {
  const { t } = useTranslation()
  const { columns, tableData } = useHook()
  return (
    <SectionBase>
      <BaseSpace>
        <BaseText
          children={t(R.strings.patient_appointments_today)}
          fontWeight="semibold"
          fontSize="md"
        />
        <BaseTableManagement
          columns={columns}
          dataSource={tableData?.data}
          loading={tableData?.loading}
          pagination={false}
          scroll={{
            x: true,
          }}
        />
      </BaseSpace>
    </SectionBase>
  )
}
